<template>
  <div class="mult-interconnection">
    <div>
      <div class="mi-module-img">
          <PlusImage :src="isPC ? CROSS_ECOLOGY.file : isPad ? CROSS_ECOLOGY.filePad : CROSS_ECOLOGY.fileH5" alt="" />
        </div>
      <div class="offic-suite-screen" data-position="5" data-name="套件页面流量">
        <div class="offic-suite-content" v-animate>
          <p class="offic-suite-title ffm500">vivo办公套件</p>
          <div class="sub-title">
            <p class="ffm600">跨端文件，想传就传</p>
          </div>
          <div v-if="!isPC" class="mi-module-desc ffm400">全新升级的vivo办公套件让跨设备传文件更简单。只要登录相同账号，任意格式、数量的文件，甚至整个文件夹，都能在手机与电脑间无损传输。
          </div>
          <div v-else class="mi-module-desc ffm400">
            <p>全新升级的vivo办公套件让跨设备传文件更简单。</p>
            <p>只要登录相同账号，任意格式、数量的文件，</p>
            <p>甚至整个文件夹，都能在手机与电脑间无损传输。</p>
          </div>
          
          <div class="offic-suite-more">
            <a href="https://pc.vivo.com/#/" :class="[isPC ? 'ffm400': 'ffm600']"
              data-track="{type:'click',params:{version:'4.9.6',cfrom:'01|03|044|002',module:'vivo办公套件',button_name:'进一步了解'}}">进一步了解
              &gt;</a>
          </div>
          <div v-if="isPC" class="offic-suite-download">
            <a href="https://pcsuite-api.vivo.com/version/download/windows/full" class="ffm500"
              data-track="{type:'click',params:{version:'4.9.6',cfrom:'01|03|044|002',module:'vivo办公套件',button_name:'windows版本'}}">下载Windows版</a>
            <a href="javascript:void(0)" class="ffm500"
              data-track="{type:'click',params:{version:'4.9.6',cfrom:'01|03|044|002',module:'vivo办公套件',button_name:'Mac版本'}}"
              @click="openMacDialog">下载Mac版</a>
            <a href="https://passport.vivo.com/#/login?client_id=131&redirect_uri=https%3A%2F%2Fpc.vivo.com%2Fsuite" class="ffm500"
              data-track="{type:'click',params:{version:'4.9.6',cfrom:'01|03|044|002',module:'vivo办公套件',button_name:'网页版本'}}">使用网页版</a>
          </div>
        </div>
        <template v-if="!isPC">
          <div class="open-in-pc">
            <div class="pc-url-wrap" @click="copyPcUrl">
              <PlusImage :src="CROSS_ECOLOGY.openInPC"></PlusImage>
            </div>
            <div v-if="isPad" class="pc-tip ffm400">
              请在电脑上打开上述网址，下载安装办公套件。
            </div>
            <div v-else class="pc-tip ffm400">
              请在电脑上打开上述网址，<br>下载安装办公套件。
            </div>
          </div>
        </template>
      </div>
    </div>

    <!-- 下载弹窗 -->
    <div class="mi-mac-dialog" v-if="dialogVisible" data-position="6" data-name="vivo办公套件Mac下载弹窗">
      <div class="mi-mac-dialog-content">
        <button class="mi-mac-dialog-close" title="关闭" @click="closeMacDialog"></button>
        <h2 class="mi-mac-dialog-title ffm400">选择合适的Mac版本</h2>
        <div class="mi-mac-dialog-download ffm600">
          <a href="https://pcsuite-api.vivo.com/version/download/mac/full?chip=2"
            data-track="{type:'click',params:{version:'4.9.6',cfrom:'01|03|044|002',module:'vivo办公套件',button_name:'下载Intel芯片版'}}">下载Intel芯片版</a>
          <a href="https://pcsuite-api.vivo.com/version/download/mac/full?chip=1"
            data-track="{type:'click',params:{version:'4.9.6',cfrom:'01|03|044|002',module:'vivo办公套件',button_name:'下载Apple芯片版（M系列）'}}">下载Apple芯片版（M系列）</a>
        </div>
        <div class="mi-mac-dialog-bottom">
          <div class="mi-mac-dialog-left">
            <p class="mi-step-title ffm500">如何确认 Mac 电脑的芯片类型</p>
            <p class="mi-step-text-1 ffm400" @mouseover="onHover1" @mouseleave="onLeave1">1、在电脑左上角，点击<span
                class="mi-mac-icon"></span><span class="mi-black ffm400">“Apple 菜单”>“关于本机”</span></p>
            <p class="mi-step-text-2 ffm400" @mouseover="onHover2" @mouseleave="onLeave2">2、在<span
                class="mi-black-1 ffm400">“概览”</span>页中查看<span class="mi-black-2 ffm400">“芯片”</span>或<span
                class="mi-black-2 ffm400">“处理器”</span>
              ，确认是“Intel”还是“Apple”</p>
            <p class="mi-step-tip ffm400">注：若无法判断电脑的芯片类型，建议点击“下载 Intel 芯片版”，确保vivo 办公套件正常使用。</p>
          </div>
          <div class="mi-mac-dialog-right">
            <transition name="fade-in">
              <template v-if="hover2">
                <PlusImage :src="CROSS_ECOLOGY.miMacHover1" key="miMacHover1"></PlusImage>
              </template>
              <template v-else>
                <PlusImage :src="CROSS_ECOLOGY.miMac" key="miMac"></PlusImage>
              </template>
            </transition>
          </div>
        </div>
      </div>
    </div>
    <Toast ref="multConnectToast" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { CROSS_ECOLOGY } from "@/config/image.js";
import PlusImage from "@/components/PlusImage.vue";
export default {
  name: 'MultInterconnection',
  components: {
    PlusImage
  },
  computed: {
    ...mapGetters(['isPC', 'isPad', 'isMobile']),
  },
  data() {
    return {
      CROSS_ECOLOGY,
      dialogVisible: false,
      // 移动端，复制网址
      showTip: false,
      timer: null,
      hover1: false,
      hover2: false
    }
  },
  watch: {
    showTip(newVal, oldVal) {
      if (newVal) {
        this.$refs.multConnectToast.show('已复制', 800)
      }
    }
  },

  methods: {
    onHover1() {
      this.hover1 = true
    },
    onHover2() {
      this.hover2 = true
    },
    onLeave1() {
      this.hover1 = false
    },
    onLeave2() {
      this.hover2 = false
    },
    openMacDialog() {
      this.dialogVisible = true
    },

    closeMacDialog() {
      this.dialogVisible = false
    },
    copyPcUrl() {
      let t = this, urlText = "pc.vivo.com";
      if (navigator.clipboard) {
        navigator.clipboard.writeText(urlText).then((function () {
          null != t.timer && clearTimeout(t.timer),
            t.showTip = !0,
            t.timer = setTimeout((function () {
              t.showTip = !1
            }
            ), 1e3)
        }
        ));
      }
      else {
        var n = document.createElement("textarea");
        document.body.appendChild(n),
          n.style.position = "fixed",
          n.style.clip = "rect(0 0 0 0)",
          n.style.top = "10px",
          n.value = urlText,
          n.select(),
          document.execCommand("copy", !0),
          null != this.timer && clearTimeout(this.timer),
          this.showTip = !0,
          this.timer = setTimeout((function () {
            t.showTip = !1
          }
          ), 1e3),
          document.body.removeChild(n)
      }
    },
  }
}
</script>
<style lang="scss" scoped>
.mult-interconnection {
  width: 100%;
  height: 900 * $px1920vw + vw;
  background: linear-gradient(180deg, #FFFFFF 55%, #F5F5F7 86%);
  position: relative;

  .mi-module-img {
    width: 100%;
    height: 900 * $px1920vw + vw;
    position: absolute;
    left: 0;
    top: 0;
    img, picture {
      width: 100%;
      height: 900 * $px1920vw + vw;
      img {
        width: 100%;
        height: 900 * $px1920vw + vw;
      }
    }
  }

  .offic-suite-screen {
    display: flex;
    align-items: end;
    width: 100%;
    padding-top: 97 * $px1920vw + vw;
    padding-left: 360 * $px1920vw + vw;
    position: relative;

    .offic-suite-content {
      width: fit-content;
      text-align: left;
      .offic-suite-title {
        font-size: 28 * $px1920vw + vw;
        line-height: 34 * $px1920vw + vw;
        color: #0F77FF;
      }

      .sub-title {
        margin-top: 12 * $px1920vw + vw;
        p {
          font-size: 64 * $px1920vw + vw;
          line-height: 77 * $px1920vw + vw;
          color: #000000;
        }
      }

      .mi-module-desc {
        margin-top: 36 * $px1920vw + vw;
        p {
          font-size: 18 * $px1920vw + vw;
          line-height: 25.33 * $px1920vw + vw;
          color: rgba(0, 0, 0, 0.6);
        }
      }

      .offic-suite-more {
        margin-top: 48 * $px1920vw + vw;
        font-size: 0;

        a {
          font-size: 18 * $px1920vw + vw;
          line-height: 21.34 * $px1920vw + vw;
          color: rgba(0, 0, 0, 0.8);
        }
      }

      .offic-suite-download {
        margin-top: 150 * $px1920vw + vw;

        a {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 200 * $px1920vw + vw;
          height: 65 * $px1920vw + vw;
          border-radius: 50 * $px1920vw + vw;
          background-color: #000;
          font-size: 18 * $px1920vw + vw;
          color: #ffffff;

          &+a {
            margin-top: 15 * $px1920vw + vw;
          }
        }
      }
    }

    .open-in-pc {
      margin-top: 51 * $px360vw + vw;
      .pc-url-wrap {
        width: 100%;
        picture {
          width: 145 * $px360vw + vw;
          height: 21 * $px360vw + vw;
        }
      }
      .pc-tip {
        font-size: 12 * $px360vw + vw;
        line-height: 16 * $px360vw + vw;
        width: auto;
        text-align: center;
        margin: 11 * $px360vw + vw auto 0 auto;
        color: #000000;
      }
    }
  }

  // 下载
  .mi-mac-dialog {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 999;

    .mi-mac-dialog-content {
      position: fixed;
      top: 50%;
      left: 50%;
      width: 800 * $px1920vw + vw;
      height: 590 * $px1920vw + vw;
      transform: translate(-50%, -50%);
      border-radius: 30 * $px1920vw + vw;
      background: #ffffff;
      border: 1px solid rgba(0, 0, 0, 0.04);
      box-shadow: 0px 10 * $px1920vw + vw 20 * $px1920vw + vw 0px rgba(0, 0, 0, 0.1);
      z-index: 500;

      .mi-mac-dialog-close {
        position: absolute;
        top: 12 * $px1920vw + vw;
        right: 20 * $px1920vw + vw;
        width: 24 * $px1920vw + vw;
        height: 24 * $px1920vw + vw;
        padding: 0;
        border: none;
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' width='24' height='24' viewBox='0 0 24 24'%3E%3Cpath d='M6.08 7.92q-.09-.091-.16-.198-.072-.106-.121-.225-.049-.118-.074-.243Q5.7 7.128 5.7 7q0-.064.006-.127.007-.064.019-.127.012-.062.031-.123t.043-.12q.024-.06.054-.116.03-.056.066-.11.036-.052.076-.102.04-.05.086-.094.045-.045.094-.086.05-.04.103-.076.053-.035.11-.065.056-.03.115-.055.059-.024.12-.043.06-.019.123-.031t.127-.019Q6.936 5.7 7 5.7q.128 0 .254.025.125.025.243.074.119.049.225.12.107.071.197.162l11 11q.09.09.162.197.071.106.12.224.049.119.074.244.025.126.025.254 0 .064-.006.127-.006.064-.019.127-.012.062-.031.123-.018.061-.043.12-.024.06-.055.116-.03.056-.065.11-.036.052-.076.102-.04.05-.086.094-.045.045-.094.086-.05.04-.103.076-.053.035-.11.066-.055.03-.114.054-.06.024-.12.043-.062.019-.124.031-.063.013-.127.019-.063.006-.127.006-.128 0-.254-.025-.125-.025-.244-.074-.118-.049-.224-.12-.107-.071-.197-.162l-11-11z' fill-rule='evenodd' fill='%23666'/%3E%3Cpath d='M6.08 17.08q-.09.091-.16.198-.072.106-.121.225-.049.118-.074.243-.025.126-.025.254 0 .064.006.127.007.064.019.127.012.062.031.123t.043.12q.024.06.054.116.03.056.066.11.036.052.076.102.04.05.086.094.045.045.094.086.05.04.103.076.053.035.11.066.056.03.115.054.059.024.12.043.06.019.123.031t.127.019q.063.006.127.006.128 0 .254-.025.125-.025.243-.074.119-.049.225-.12.107-.071.197-.162l11-11q.09-.09.162-.197.071-.106.12-.224.049-.119.074-.244.025-.126.025-.254 0-.064-.006-.127-.006-.064-.019-.127-.012-.062-.031-.123-.018-.061-.043-.12-.024-.06-.055-.116-.03-.056-.065-.11-.036-.052-.076-.102-.04-.05-.086-.094-.045-.045-.094-.086-.05-.04-.103-.076-.053-.035-.11-.065-.055-.03-.114-.055-.06-.025-.12-.043-.062-.019-.124-.031-.063-.013-.127-.019Q18.064 5.7 18 5.7q-.128 0-.254.025-.125.025-.244.074-.118.049-.224.12-.107.071-.197.162l-11 11z' fill-rule='evenodd' fill='%23666'/%3E%3C/svg%3E");
        cursor: pointer;
      }

      .mi-mac-dialog-title {
        padding-top: 64 * $px1920vw + vw;
        font-family: vivoSansSCVF500;
        font-size: 24 * $px1920vw + vw;
        line-height: 24 * $px1920vw + vw;
        text-align: center;
        color: #000000;
      }

      .mi-mac-dialog-download {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding-top: 28 * $px1920vw + vw;

        a {
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 44 * $px1920vw + vw;
          width: 300 * $px1920vw + vw;
          height: 72 * $px1920vw + vw;
          font-family: vivoSansSCVF600;
          font-size: 18 * $px1920vw + vw;
          line-height: 26 * $px1920vw + vw;
          text-align: center;
          color: #ffffff;

          &:first-of-type {
            background: #000000;
          }

          &:last-of-type {
            margin-top: 20 * $px1920vw + vw;
            color: #000000;
            border: 5 * $px1920vw + vw solid #000000;
          }
        }
      }

      .mi-mac-dialog-bottom {
        display: flex;
        width: 100%;
        height: 277 * $px1920vw + vw;
        margin-top: 27 * $px1920vw + vw;
        padding: 0 40 * $px1920vw + vw;
        border-radius: 0 0 30 * $px1920vw + vw 30 * $px1920vw + vw;
        background: #fafafc;

        .mi-mac-dialog-left {
          flex: 1;

          .mi-step-title {
            padding-top: 28 * $px1920vw + vw;
            font-family: vivoSansSCVF500;
            font-size: 18 * $px1920vw + vw;
            line-height: 26 * $px1920vw + vw;
            color: #000000;
            text-align: left;
          }

          .mi-step-text-1 {
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            width: 402 * $px1920vw + vw;
            height: 38 * $px1920vw + vw;
            margin-top: 16 * $px1920vw + vw;
            padding: 12 * $px1920vw + vw 10 * $px1920vw + vw;
            border-radius: 6 * $px1920vw + vw;
            font-family: vivoSansSCVF500;
            font-size: 14 * $px1920vw + vw;
            line-height: 14 * $px1920vw + vw;
            color: #878787;
            text-align: left;

            &:hover {
              background: rgba(87, 156, 248, 0.1025);
            }

            &.active {
              background: rgba(87, 156, 248, 0.1025);
            }

            .mi-mac-icon {
              display: block;
              width: 12 * $px1920vw + vw;
              height: 14 * $px1920vw + vw;
              margin: 0 0.26vw;
              background-repeat: no-repeat;
              background-position: center;
              background-size: contain;
              background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' width='11.36' height='13.84' viewBox='0 0 11.36 13.84'%3E%3Cpath d='M11.36 10.144c-.017.053-.29 1-.964 1.975-.582.84-1.185 1.688-2.136 1.703-.937.017-1.236-.553-2.304-.553-1.067 0-1.402.538-2.286.57-.915.037-1.619-.919-2.203-1.755C.271 10.37-.648 7.227.585 5.12c.609-1.054 1.7-1.724 2.888-1.743.896-.016 1.748.602 2.292.602.56 0 1.59-.748 2.677-.636.455.02 1.73.188 2.55 1.368-.064.044-1.524.898-1.507 2.638.021 2.099 1.856 2.787 1.875 2.794zM7.731 2.22C8.221 1.626 8.544.81 8.46 0c-.7.027-1.554.461-2.06 1.052-.45.514-.844 1.343-.734 2.143.778.047 1.578-.404 2.066-.976z' fill='%232C2C2C'/%3E%3C/svg%3E");
            }

            .mi-black {
              color: #1d1d1d;
            }
          }

          .mi-step-text-2 {
            cursor: pointer;
            width: 402 * $px1920vw + vw;
            height: 48 * $px1920vw + vw;
            margin-top: 12 * $px1920vw + vw;
            padding: 0 10 * $px1920vw + vw;
            font-family: vivoSansSCVF500;
            font-size: 14 * $px1920vw + vw;
            line-height: 24 * $px1920vw + vw;
            text-align: left;
            color: #878787;

            &:hover {
              background: rgba(87, 156, 248, 0.1025);
            }

            &.active {
              background: rgba(87, 156, 248, 0.1025);
            }

            .mi-black-1 {
              color: #121212;
            }

            .mi-black-2 {
              color: #000000;
            }
          }

          .mi-step-tip {
            width: 358 * $px1920vw + vw;
            height: 36 * $px1920vw + vw;
            margin-top: 33 * $px1920vw + vw;
            font-family: vivoSansSCVF500;
            font-size: 11 * $px1920vw + vw;
            line-height: 18 * $px1920vw + vw;
            color: rgba(0, 0, 0, 0.3);
            text-align: left;
          }
        }

        .mi-mac-dialog-right {
          width: 264 * $px1920vw + vw;
          height: 172 * $px1920vw + vw;
          margin-top: 54 * $px1920vw + vw;
          flex-shrink: 0;

          picture {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
}

.isPad {
  .mult-interconnection {
    height: 560 * $px676vw + vw;
    padding-bottom: 42 * $px676vw + vw;
    .mi-module-img {
      height: 560 * $px676vw + vw;
      img, picture {
        height: 560 * $px676vw + vw;
        img {
          height: 560 * $px676vw + vw;
        }
      }
    }
    .offic-suite-screen {
      padding-top: 36 * $px676vw + vw;
      padding-left: 0;
      display: inline-block;
      .offic-suite-content {
        width: 100%;
        text-align: center;
        .offic-suite-title {
          font-size: 12 * $px676vw + vw;
          line-height: 14 * $px676vw + vw;
        }
        .sub-title {
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: 6 * $px676vw + vw;
          p {
            font-size: 25 * $px676vw + vw;
            line-height: 29 * $px676vw + vw;
          }
        }
        .mi-module-desc {
          margin-top: 12 * $px676vw + vw;
          padding: 0 176 * $px676vw + vw;
          color: rgba(0, 0, 0, 0.6);
          font-size: 12 * $px676vw + vw;
          line-height: 16 * $px676vw + vw;
        }
        .offic-suite-more {
          margin-top: 12 * $px676vw + vw;
          font-size: 0;
          a {
            font-size: 12 * $px676vw + vw;
            line-height: 14 * $px676vw + vw;
            color: rgba(0, 0, 0, 1);
            opacity: 0.8;
          }
        }
      }
      .open-in-pc {
        margin-top: 305 * $px676vw + vw;
        font-size: 0;
        .pc-url-wrap {
          width: auto;
          height: auto;
          picture {
            width: 145 * $px676vw + vw;
            height: 21 * $px676vw + vw;
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
        .pc-tip {
          font-size: 12 * $px676vw + vw;
          line-height: 16 * $px676vw + vw;
          margin-top: 12 * $px676vw + vw;
        }
      }
    }
  }
}

.isMobile {
  .mult-interconnection {
    height: 560 * $px360vw + vw;
    padding-bottom: 42 * $px360vw + vw;
    .mi-module-img {
      height: 560 * $px360vw + vw;
      img, picture {
        width: 100%;
        height: 560 * $px360vw + vw;
        img {
          width: 100%;
          height: 560 * $px360vw + vw;
        }
      }
    }
    .offic-suite-screen {
      padding-top: 36 * $px360vw + vw;
      padding-left: 0;
      display: inline-block;
      .offic-suite-content {
        width: 100%;
        text-align: center;
        .offic-suite-title {
          font-size: 12 * $px360vw + vw;
          line-height: 14 * $px360vw + vw;
        }
        .sub-title {
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: 6 * $px360vw + vw;
          p {
            font-size: 25 * $px360vw + vw;
            line-height: 29 * $px360vw + vw;
          }
        }
        .mi-module-desc {
          margin-top: 12 * $px360vw + vw;
          font-size: 12 * $px360vw + vw;
          line-height: 16 * $px360vw + vw;
          padding: 0 31 * $px360vw + vw;
          color: rgba(0, 0, 0, 0.6);
        }
        .offic-suite-more {
          margin-top: 12 * $px360vw + vw;
          font-size: 0;

          a {
            line-height: 14 * $px360vw + vw;
            font-size: 12 * $px360vw + vw;
            color: rgba(0, 0, 0, 1);
            opacity: 0.8;
          }
        }
      }
      .open-in-pc {
        margin-top: 283 * $px360vw + vw;
        font-size: 0;
        .pc-url-wrap {
          width: auto;
          height: auto;
          picture {
            width: 145 * $px360vw + vw;
            height: 21 * $px360vw + vw;
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
        .pc-tip {
          font-size: 12 * $px360vw + vw;
          line-height: 16 * $px360vw + vw;
          margin-top: 12 * $px360vw + vw;
        }
      }
    }
  }
}
</style>
